export default __webpack_public_path__ + "static/media/1627.60403b86.png";